import React from "react";
import { Tooltip } from "@mui/material";

/**
 * Tooltip component with blue info icon
 * @param {Object} props
 * @param {string} props.text - Tooltip text
 * @returns {import("react").ReactElement}
 */
export default function BlueInfoTooltip(props) {
  const { text } = props;

  return (
    <Tooltip title={text} slotProps={{ tooltip: { sx: { fontSize: "1.2rem" } } }}>
      <img src="/images/icons/tool-tip.svg" />
    </Tooltip>
  );
}
